import { useEffect } from "react";
import { useRole } from "@/contexts/RoleContext";
import { preloadRoleRoutes } from "@/lib/routePreload";

/**
 * Role-aware idle route preloader.
 * Waits for RoleContext to resolve, then during browser idle time warms up
 * the chunks for the top-level nav routes belonging to that role. Fire-and-
 * forget; failures are non-fatal.
 */
export function RoutePreloader() {
  const { roleResolution, userRole, allRoles } = useRole();

  useEffect(() => {
    if (roleResolution !== "resolved") return;
    const ric: (cb: () => void) => number =
      (window as unknown as { requestIdleCallback?: (cb: () => void) => number })
        .requestIdleCallback?.bind(window) ??
      ((cb: () => void) => window.setTimeout(cb, 1500));
    const handle = ric(() => {
      preloadRoleRoutes(userRole, allRoles ?? []);
    });
    return () => {
      const cic = (window as unknown as { cancelIdleCallback?: (h: number) => void })
        .cancelIdleCallback;
      if (cic) cic(handle);
      else window.clearTimeout(handle);
    };
  }, [roleResolution, userRole, allRoles]);

  return null;
}
